import { Button, Card, Icon } from '@innovationnorway/cl-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  clusterName: string | undefined;
  onInitialFeedbackProvided: (isCorrectlyReferred: boolean) => void;
};

const InitialFeedback: React.FC<Props> = ({ clusterName, onInitialFeedbackProvided }) => {
  const { t: tCommon } = useTranslation('common');
  const { t: tOneWayIn } = useTranslation('oneWayIn');

  return (
    <Card className="display--flex flex-direction--column">
      <div className="display--flex flex-wrap--wrap gap--2 align-items--center font-weight--bold">
        <span className="font-size--large">
          {tOneWayIn('opportunity.feedback.intro.2')} ({clusterName})
        </span>
      </div>
      <div className="display--flex">
        <div className="display--flex flex-direction--column">
          <p className="margin--0">{tOneWayIn('opportunity.feedback.intro.1')}</p>
          <p className="margin--0 max-inline-size--90">{tOneWayIn('opportunity.feedback.intro.3')}</p>
        </div>
        <div className="display--flex gap--2 align-self--flex-end">
          <Button onClick={() => onInitialFeedbackProvided(true)} variant="secondary">
            <Icon prefix="fasr" iconName="thumbs-up" />
            {tCommon('yes')}
          </Button>
          <Button onClick={() => onInitialFeedbackProvided(false)} variant="secondary">
            <Icon prefix="fasr" iconName="thumbs-down" />
            {tCommon('no')}
          </Button>
        </div>
      </div>
    </Card>
  );
};

export default InitialFeedback;
